import React from "react";
export const Opinion = () => {
  return (
    <div className="opinion-wrap">
      <h1>
        最高人民法院、最高人民检察院、公安部
         关于依法处理信访活动中违法犯罪行为的指导意见
      </h1>
      <div className="text-cont">
        为进一步维护社会治安秩序，引导信访人员合法维权，切实把信访维权纳入法治化轨道，增强全民依法、逐级、有序信访的理念，依法保障信访人的合法权益，依照《中华人民共和国刑法》《中华人民共和国刑事诉讼法》《中华人民共和国治安管理处罚法》《最高人民法院、最高人民检察院关于办理寻衅滋事刑事案件适用法律若干问题的解释》(法释〔2013〕18号)、《最高人民法院、最高人民检察院关于办理利用信息网络实施诽谤等刑事案件适用法律若干问题的解释》(法释〔2013〕21号)等法律法规和司法解释，制定本指导意见。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; 一、依法打击违法犯罪行为，明确法律底线。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;
        (一)扰乱公共秩序。在信访活动中或者以信访为名，实施下列行为的，依照刑法有关规定定罪处罚：
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; 1.在各级党委、人大、政协、行政、监察、审判、检察、军事机关，厂矿、商场等企业单位，学校、医院、报社、电视台、科研院所等事业单位，工会、妇联等社会团体单位，机场、车站、码头等重要交通场站，或者在上述场所周边的其他公共场所，聚众实施统一着装、佩戴统一标识、静坐滞留、张贴散发材料、喊口号、打横幅、穿状衣等行为，或者实施跳楼、服毒等自杀、自伤行为以及扬言实施自杀、自伤行为，情节严重，致使工作、生产、营业和教学、科研、医疗活动无法进行，造成严重损失的，依照刑法第二百九十条第一款的规定，对首要分子和其他积极参加者，以聚众扰乱社会秩序罪定罪处罚；
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;  2.在各级党委、人大、政协、行政、监察、审判、检察、军事机关，聚众实施强行冲闯、圄堵大门通道，围攻、辱骂工作人员，强占办公场所，投掷石块杂物等冲击国家机关行为，致使国家机关工作无法进行，造成严重损失的，依照刑法第二百九十条第二款的规定，对首要分子和其他积极参加者，以聚众冲击国家机关罪定罪处罚；
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;3.聚众扰乱车站、码头、民用航空站、商场、公园、影剧院、展览会、运动场及周边公共场所或者其他公共场所秩序，聚众堵塞交通或者破坏交通秩序，抗拒、阻碍国家治安管理工作人员依法执行职务，情节严重的，依照刑法第二百九十一条的规定，对首要分子，以聚众扰乱公共场所秩序、交通秩序罪定罪处罚；
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;4.个人多次扰乱国家机关的工作秩序，经行政处罚后仍不改正，造成严重后果的，依照刑法第二百九十条第三款的规定，以扰乱国家机关工作秩序罪定罪处罚；
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; (二)组织、资助非法聚集。多次组织、资助他人到各级党委、人大、政协、行政、监察、审判、检察、军事机关，厂矿、商场等企业单位，学校、医院、报社、电视合、科研院所等事业单位，工会、妇联等社会团体单位，机场、车站、码头等重要交通场站，或者到上述场所周边的其他公共场所，非法聚集，扰乱社会秩序，情节严重的，依照刑法第二百九十条第四款的规定，以组织、资助非法聚集罪定罪处罚。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;(三)寻衅滋事。在信访活动中或者以信访为名，为制造影响或者发泄不满，实施下列行为之一的，依照刑法第二百九十三条的规定，以寻衅滋事罪定罪处罚；
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;1.在各级党委、人大、政协、行政、监察、审判、检察、军事机关，厂矿、商场等企业单位，学校、医院、报社、电视台、科研院所等事业单位，工会、妇联等社会团体单位，机场、车站、码头等重要交通场站，或者在上述场所周边的其他公共场所，实施自杀、自伤、打横幅、撒传单、拦车辆、统一着装、佩戴统一标识等行为，起哄闹事，造成公共场所秩序严重混乱的；
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;2.追逐、拦截、辱骂、恐吓、随意殴打他人，情节恶劣的，或者强拿硬要、任意损毁、占用公私财物，情节严重的；
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;3.编造虚假信息，或者明知是编造的虚假信息，在信息网络上散布，或者组织、指使人员在信息网络上散布，起哄闹事，造成公共序严重混乱的。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;实施寻衅滋事行为，同时符合寻衅滋事罪、故意杀人罪、故意伤害罪、故意毁坏财物罪、敲诈勒索罪、抢夺罪、抢劫罪等犯罪的构成要件的，依照处罚较重的犯罪定罪处罚。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;（四)阻碍执行职务。在信访活动中或者以信访为名，以暴力、威胁方法阻碍国家机关工作人员依法执行职务的，依照刑法第二百七十七条的规定，以妨害公务罪定罪处罚；暴力袭击正在依法执行职务的人民警察的，依法从重处罚。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;（五)非法携带枪支、弹药、管制刀具、危险物品。非法携带枪支、弹药、管制刀具或者爆炸性、易燃性、放射性、毒害性、腐蚀性物品进入公共场所或者公共交通工具，危及公共安全，情节严重的，依照刑法第一百三十条的规定，以非法携带枪支、弹药、管制刀具、危险物品危及公共安全罪定罪处罚。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;(六)信息网络有关行为。设立网站、通讯群组，用于在信访活动中或者以信访为名实施违法犯罪活动，情节严重的，依照刑法第二百八十七条之一的规定，以非法利用信息网络罪定罪处罚；明知他人利用信息网络在信访活动中或者以信访为名实施犯罪行为，为其提供技术支持或者其他帮助，情节严重的，依照刑法第二百八十七条之二的规定，以帮助信息网络犯罪活动罪定罪处罚；网络服务提供者不履行法律、行政法规规定的信息网络安全管理义务，经监管部门责令采取改正措施而拒不改正，情节严重的，依照刑法第二百八十六条之一的规定，以拒不履行信息网络安全管理义务罪定罪处罚。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; (七)共同违法犯罪。在信访活动中或者以信访为名，煽动教唆、组织、策划、指挥他人实施违法犯罪行为的，应当按照其在共同违法犯罪中所起的作用以及违法犯罪情节予以处罚。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;(八)在特定场所实施犯罪行为。对在天安门广场、中南海地区、党和国家领导人住地、国家重大活动举办场馆、中央国家机关所在地、中央军委大楼、中央主要新闻单位办公场所、外国驻华使领馆、国宾下榻处等非信访场所实施本条第一项至第五项规定的行为，在认定“造成严重损失”“情节严重”“造成严重后果”“造成公共场所秩序严重混乱”“情节恶劣”等入罪情节时，要将上述场所作为重要考虑因素；构成相关犯罪的，从重处罚。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;(九)治安管理处罚或者其他行政处罚。实施本条第一项至第六项规定的行为，不构成犯罪、依法不起诉或者免予刑事处罚的，依法予以治安管理处罚或者其他行政处罚；在本条第八项所列场所实施违反治安管理行为的，从重处罚，依法可以行政拘留的，依法予以行政拘留。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;二、坚持宽严相济，教育帮助绝大多数     
        办理此类案件，应当坚持宽严相济，惩治与教育相结合，依法打击极少数，教育帮助绝大多数。对煽动、教唆、组织、策划指挥实施和积极参与非法聚集，与其他利益诉求群体串联“抱团”实施相关违法犯罪行为，实施殴打国家机关工作人员、打砸公私财物等暴力犯罪行为，利用信息网络制造、传播、主动向境外提供相关虚假信息、企图以外压内，多次到本指导意见第一条第八项所列场所表达诉求，以及专门利用国家重大活动和全国“两会”“七一”“十一”等重要时间节点进京在非信访场所表达诉求、滋事扰序，向地方政府施压的人员，要作为打击重点。对有正当信访事由且初次实施违法行为、情节轻微，或者被引诱、胁迫参与，经劝阻、训诫或者制止，立即停止实施的，可以依法不予处罚。对一般参与、情节较轻，行为人认识到违法犯罪行为危害性，确有悔过表现，明确表示依法信访，或者具有自首、立功表现的，可以依法从轻、减轻或者免予处罚。对自愿如实供述自己的罪行，承认指控的犯罪事实，愿意接受处罚的，可以依法从宽处理。对实施造法犯罪行为而依法不予行政处罚、不负刑事责任的精神病人，应当及时通报居住地公安机关，责令其家属或者监护人严加看管和送医治疗，必要时依法强制医疗。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;三、强化协作配合，严格依法规范执法办案,
         公安机关、人民检察院、人民法院既要加强内部协作，也要加强相互之间以及与相关部门的沟通配合，通过多种方式引导群众依法维权。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; (一)明确职责。对越级走访，多人就同一信访事项到信访接待场所走访但拒不按照规定推选集体访代表，拒不通过法定途径提出投诉请求，不依照法定程序申请信访事项复查、复核，或者信访诉求已经依法解决，仍然以同一事实和理由提出投诉请求，在信访接待场所多次缠访，在信访接待场所滞留、滋事，或者将年老、年幼、体弱、患有严重疾病、肢体残疾等生活不能自理的人弃留在信访接待场所等情形，由相关国家机关工作人员进行劝阻、批评或者教育。经劝祖、批评和教育无效的，对堵门、堵路、拦车、长时间滞留、采取过激行为的，公安机关应当依法予以警告、训诚或者制止，依法采取处置措施；构成违反治安管理行为或者犯罪的，依法追究法律责任。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; (二)明确案件管辖。此类案件，由违法犯罪地公安机关管辖，由居住地公安机关管辖更为适宜的，可以由居住地公安机关管辖。违法犯罪地在北京市，且在本指导意见第一条第八项所列场所的，由北京市公安机关管辖；违法犯罪地在北京市其他地区，由居住地公安机关管辖更为适宣的，可以由居住地公安机关管辖。对管辖权发生争议的，报请共同的上级公安机关指定管辖。移送、指定居住地公安机关管辖的案件，需要提请批准逮捕、移送审查起诉、提起公诉的，由该公安机关所在地的人民检察院、人民法院受理。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; (三)做好证据移交。对需要将案件移送居住地公安机关的，违法犯罪地公安机关应当及时移交执法视音频资料，扣押、收缴的物证书证，违法犯罪嫌疑人供述，查获嫌疑人的登记记录和依法开具的训诫书等合法有效证据。执法视音频资料应当能够全面不间断展示违法犯罪实施情况，现场扣押、收缴相关传单、标语、横幅等物品时应当标明物品来源，登记记录中应当对查获嫌疑人的时间、地点等内容进行详实、准确记载。不移交证明现场违法犯罪事实的主要证据的，居住地公安机关可以不接受移送的案件，同时报告上一级公安机关。
        <br />
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; 四、加强宣传教育，引导信访人合法维权
    在办理此类案件过程中，公安机关、人民检察院、人民法院要加大法制宣传教育力度；引导群众依法理性表达诉求。对违法犯罪嫌疑人、被告人，要同步开展法制宣传、告知信访权利义务结合案情充分释法说理，讲明实施违法犯罪行为对自己、家庭、他人、社会的危害性，促使其认识到错误和危害。同时，对非法聚集、暴力袭警等性质恶劣，企图通过违法犯罪行为实现不合理诉求的组织者、策划者要适时依法揭批、公开曝光。要通过依法打击和法制宣传，明确规矩、划清底线，彻底打消一些人“大闹大解决、小闹小解决、不闹不解决”的心理，引导群众依法理性维护合法权益，自觉运用法律手段解决矛盾纠纷，在全社会树立“维权不能违法”“法律红线不可逾越、法律底线不可触碰”的法治观念，增强全民依法信访的理念，营造“解决问题用法、化解矛盾靠法”的良好法治环境。
        <br />
        <br />
      </div>

      <br />
    </div>
  );
};
